import createCache from '@emotion/cache';

// Create a singleton cache for consistent server/client hydration
let cache;

export default function createEmotionCache() {
  // Ensure consistent cache creation between server and client
  if (!cache || typeof window === 'undefined') {
    cache = createCache({ 
      key: 'css', 
      prepend: true,
      // Enable insertion point for better style ordering in production
      insertionPoint: typeof document !== 'undefined' 
        ? document.querySelector('meta[name="emotion-insertion-point"]') || undefined 
        : undefined 
    });
  }
  return cache;
}
